import Image from 'next/image';
import { bannerTypes, imageTypes, screenTypes } from '@/constants/types';
import React, { useState } from 'react';
import { cn } from '@/utils/cn';
import useIsomorphicLayoutEffect from 'use-isomorphic-layout-effect';
import { getImageUrl } from '@/utils/string';

const fallbackMap = {
  [imageTypes.bannerDesktop]: '/images/banner-desktop-fallback.png',
  [imageTypes.bannerMobile]: '/images/banner-mobile-fallback.png',
};

const imageBlurDataURL =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVR42mN8//HLfwYiAOOoQvoqBABbWyZJf74GZgAAAABJRU5ErkJggg==';

function BannerImageComponent({
  mobileSrc = null,
  desktopSrc = null,
  alt = '',
  className = '',
  priority = true,
  type = bannerTypes.default, // for campaign, brand, campaign plp, popular deals 1
  unoptimized = true,
}) {
  const [src, setSrc] = useState(imageBlurDataURL);
  const [hasError, setHasError] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const isMobile = window.innerWidth <= screenTypes.medium;

    if (hasError) {
      setSrc(
        isMobile
          ? fallbackMap[imageTypes.bannerMobile]
          : fallbackMap[imageTypes.bannerDesktop],
      );
    } else if (isMobile && mobileSrc) {
      setSrc(getImageUrl(mobileSrc));
    } else if (!isMobile && desktopSrc) {
      setSrc(getImageUrl(desktopSrc));
    } else {
      setSrc(
        isMobile
          ? fallbackMap[imageTypes.bannerMobile]
          : fallbackMap[imageTypes.bannerDesktop],
      );
    }
  }, [mobileSrc, desktopSrc, hasError]);

  return (
    <div
      className={cn('relative w-full h-auto', className, {
        'aspect-[1.040/1] md:aspect-[4.114/1]':
          type === bannerTypes.homePageHero,
        'aspect-[1.025/1] md:aspect-[1.86466/1] rounded-xl lg:rounded-3xl':
          type === bannerTypes.homepageMarketingBannerCarousel,
        'aspect-[2/1] md:aspect-[4.114/1]': type === bannerTypes.default,
        'aspect-[0.9512/1] md:aspect-[1.70/1] rounded-xl lg:rounded-3xl':
          type === bannerTypes.popularDeals23,
        'aspect-[2/1] md:aspect-[3.44444/1] rounded-xl lg:rounded-3xl':
          type === bannerTypes.popularDeals1,
        'aspect-[1.27/1] lg:aspect-[1.27/1] h-full':
          type === bannerTypes.singleBannerCarousel,
        'aspect-[1.78/1] rounded-xl lg:rounded-3xl h-full':
          type === bannerTypes.homepageSingleMediaBannerCarousel,
      })}
    >
      <Image
        fill
        quality={90}
        src={src}
        alt={alt}
        className="next-banner-image-component object-cover object-center"
        placeholder="blur"
        blurDataURL={imageBlurDataURL}
        sizes="(max-width: 768px) 100vw, 1440px"
        priority={priority}
        onError={() => {
          if (!hasError) setHasError(true);
        }}
        unoptimized={unoptimized}
      />
    </div>
  );
}

// function BannerImageComponent({
//   src = null,
//   alt = '',
//   className = '',
//   imageObj = null, // TODO: this will update later to handle full image object and process it accordingly
//   priority = true,
//   type = bannerTypes.default, // TODO: this will update later to handle full banner object and process it accordingly
//   ...rest
// }) {
//   const [hasError, setHasError] = useState(false);
//   const fallbackSrc = fallbackMap[imageTypes.banner];

//   // If there's an error or no source images available, use fallback
//   const shouldUseFallback = src === null || hasError;

//   // Function to determine the appropriate image source
//   const determineImageSource = () => {
//     if (shouldUseFallback) {
//       return fallbackSrc;
//     }

//     return src;
//   };

//   return (
//     <Image
//       quality={90}
//       src={determineImageSource()}
//       alt={alt}
//       className={cn('next-banner-image-component', className, {
//         'w-full object-center object-cover md:object-contain lg:object-cover aspect-[1.040/1] md:aspect-[4.114/1]':
//           type === bannerTypes.homePageHero,
//         'w-full aspect-[1.02/1] lg:aspect-[1.8/1] object-center object-contain':
//           type === bannerTypes.homepageMarketingBannerCarousel,
//       })}
//       onError={() => {
//         if (!hasError) setHasError(true);
//       }}
//       placeholder="blur"
//       blurDataURL={imageBlurDataURL}
//       // TODO: Remove this when the image optimization is stable
//       // This is a temporary fix to avoid issues with Next.js image optimization
//       // unoptimized
//       sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
//       priority={priority}
//       {...rest}
//     />
//   );
// }

export default BannerImageComponent;
